import { render, staticRenderFns } from "./qywxlogin.vue?vue&type=template&id=4c63b99e&"
import script from "./qywxlogin.vue?vue&type=script&lang=js&"
export * from "./qywxlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports